function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKppLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 444 223",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "logoPrimary"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.095,0l-71.19,0l0,1.873c9.601,0.703 19.203,3.981 19.203,14.754c0,6.791 -4.684,14.987 -10.773,22.012l1.171,1.405c11.007,-9.601 24.823,-21.31 37,-28.803c8.665,-5.387 17.329,-8.665 24.589,-9.368l0,-1.873Zm5.854,149.171l-0,-1.874c-10.538,-2.341 -18.734,-10.538 -26.696,-18.968c-12.411,-13.114 -43.791,-53.861 -56.905,-72.829l-21.31,24.12c9.133,15.456 21.076,32.551 32.082,46.367c13.583,16.861 23.184,20.14 37.937,21.779c10.538,1.171 29.506,1.405 34.892,1.405Zm-151.278,-29.038c0,19.436 -5.152,25.057 -19.671,27.164l0,1.874l72.829,-0l-0,-1.874c-13.816,-2.107 -19.437,-7.025 -19.437,-27.164l-0,-91.095c-0,-20.139 5.621,-25.057 19.437,-27.165l-0,-1.873l-72.829,-0l-0,1.873c14.519,2.108 19.671,7.728 19.671,27.165l-0,91.095Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.43,40.278c0,-22.715 -13.816,-35.829 -47.538,-39.341c-4.917,-0.469 -13.114,-0.937 -16.86,-0.937l0,1.873c3.278,0.469 6.088,1.171 8.43,2.108c15.222,5.62 21.31,16.861 21.31,36.766c0,21.778 -4.918,32.082 -19.202,38.405c-3.279,1.405 -6.792,2.576 -10.538,3.278l0,2.108c42.854,-1.639 64.398,-22.949 64.398,-44.26Zm-76.341,-40.278l-53.393,0l0,1.873c14.519,2.108 19.671,7.728 19.671,27.165l0,91.095c0,19.436 -5.152,25.057 -19.671,27.164l0,1.874l77.045,0l0,-1.874c-15.456,-2.107 -23.652,-7.025 -23.652,-27.164l0,-120.133Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444,40.278c0,-22.715 -13.816,-35.829 -47.538,-39.341c-4.918,-0.469 -13.114,-0.937 -16.861,-0.937l0,1.873c3.279,0.469 6.089,1.171 8.431,2.108c15.221,5.62 21.31,16.861 21.31,36.766c0,21.778 -4.918,32.082 -19.203,38.405c-3.278,1.405 -6.791,2.576 -10.538,3.278l0,2.108c42.855,-1.639 64.399,-22.949 64.399,-44.26Zm-76.342,-40.278l-53.392,0l0,1.873c14.519,2.108 19.671,7.728 19.671,27.165l0,91.095c0,19.436 -5.152,25.057 -19.671,27.164l0,1.874l77.044,0l0,-1.874c-15.456,-2.107 -23.652,-7.025 -23.652,-27.164l0,-120.133Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "logoSecondary"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.002,222.36l-3.888,0l-4.036,-10.188l-14.52,-0l-3.987,10.188l-3.839,0l13.683,-33.666l3.003,0l13.584,33.666Zm-9.106,-13.191l-6.103,-15.405l-6.054,15.405l12.157,0Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.395,198.686c0,-1.969 -0.656,-3.544 -1.969,-4.725c-1.312,-1.181 -2.969,-1.772 -4.971,-1.772l-8.269,-0l0,13.24l7.925,-0c2.198,-0 3.962,-0.566 5.291,-1.698c1.329,-1.132 1.993,-2.814 1.993,-5.045Zm5.808,23.674l-4.381,0l-9.499,-13.929l-7.137,0l0,13.929l-3.494,0l-0,-33.173l11.911,-0c2.953,-0 5.406,0.845 7.358,2.534c1.952,1.69 2.929,3.995 2.929,6.916c-0,2.625 -0.73,4.741 -2.191,6.349c-1.46,1.608 -3.322,2.592 -5.586,2.953l10.09,14.421Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.924,205.823c0,-2.264 0.304,-4.414 0.911,-6.448c0.607,-2.034 1.509,-3.864 2.707,-5.488c1.197,-1.624 2.772,-2.92 4.725,-3.888c1.952,-0.968 4.159,-1.452 6.62,-1.452c4.921,-0 8.908,1.821 11.96,5.463l-2.56,2.264c-2.461,-3.117 -5.561,-4.676 -9.302,-4.676c-3.708,0 -6.546,1.395 -8.515,4.184c-1.969,2.789 -2.953,6.12 -2.953,9.991c0,3.872 0.984,7.203 2.953,9.992c1.969,2.789 4.807,4.183 8.515,4.183c3.741,0 6.841,-1.558 9.302,-4.675l2.56,2.264c-3.052,3.642 -7.039,5.463 -11.96,5.463c-3.249,0 -6.038,-0.837 -8.368,-2.51c-2.329,-1.674 -4.011,-3.774 -5.045,-6.3c-1.033,-2.527 -1.55,-5.316 -1.55,-8.367Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.527,222.36l-3.495,0l0,-15.651l-19.54,-0l0,15.651l-3.494,0l-0,-33.173l3.494,-0l0,14.372l19.54,-0l0,-14.372l3.495,-0l-0,33.173Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.646,
    y: 189.187,
    width: 3.495,
    height: 33.174,
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.885,192.337l-12.255,-0l-0,30.023l-3.495,0l0,-30.023l-12.304,-0l-0,-3.15l28.054,-0l0,3.15Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.296,222.36l-20.721,0l0,-33.173l19.737,-0l0,3.15l-16.242,-0l-0,11.32l14.766,-0l-0,3.052l-14.766,-0l-0,12.501l17.226,0l0,3.15Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.494,205.823c0,-2.264 0.304,-4.414 0.911,-6.448c0.607,-2.034 1.509,-3.864 2.707,-5.488c1.197,-1.624 2.772,-2.92 4.725,-3.888c1.952,-0.968 4.159,-1.452 6.62,-1.452c4.922,-0 8.908,1.821 11.96,5.463l-2.559,2.264c-2.461,-3.117 -5.562,-4.676 -9.303,-4.676c-3.708,0 -6.546,1.395 -8.515,4.184c-1.968,2.789 -2.953,6.12 -2.953,9.991c0,3.872 0.985,7.203 2.953,9.992c1.969,2.789 4.807,4.183 8.515,4.183c3.741,0 6.842,-1.558 9.303,-4.675l2.559,2.264c-3.052,3.642 -7.038,5.463 -11.96,5.463c-3.249,0 -6.038,-0.837 -8.367,-2.51c-2.33,-1.674 -4.012,-3.774 -5.045,-6.3c-1.034,-2.527 -1.551,-5.316 -1.551,-8.367Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.224,192.337l-12.255,-0l-0,30.023l-3.495,0l0,-30.023l-12.305,-0l0,-3.15l28.055,-0l0,3.15Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.436,195.93c-2.166,-2.888 -5.004,-4.332 -8.515,-4.332c-2.362,0 -4.143,0.484 -5.34,1.452c-1.198,0.968 -1.797,2.256 -1.797,3.864c0,1.181 0.337,2.198 1.009,3.052c0.673,0.853 1.551,1.542 2.633,2.067c1.083,0.525 2.281,1.009 3.593,1.452c1.313,0.443 2.625,0.927 3.938,1.452c1.312,0.525 2.51,1.132 3.593,1.821c1.083,0.689 1.961,1.624 2.633,2.805c0.673,1.181 1.009,2.56 1.009,4.135c0,2.953 -1.083,5.241 -3.248,6.866c-2.166,1.624 -4.971,2.436 -8.417,2.436c-4.922,-0 -8.908,-1.772 -11.96,-5.316l2.609,-2.411c2.428,3.117 5.578,4.675 9.45,4.675c2.526,0 4.479,-0.508 5.857,-1.525c1.378,-1.018 2.067,-2.379 2.067,-4.086c-0,-1.771 -0.632,-3.207 -1.895,-4.306c-1.263,-1.099 -2.797,-1.944 -4.602,-2.535c-1.805,-0.591 -3.609,-1.206 -5.414,-1.846c-1.805,-0.64 -3.339,-1.632 -4.602,-2.977c-1.263,-1.346 -1.895,-3.085 -1.895,-5.218c0,-2.526 0.894,-4.643 2.683,-6.349c1.788,-1.706 4.454,-2.559 7.998,-2.559c2.329,-0 4.372,0.394 6.127,1.181c1.756,0.788 3.405,2.084 4.947,3.888l-2.461,2.314Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKppLogoFull);
export default __webpack_public_path__ + "static/media/kpp-logo-full.9075b79422d6fb0b61cea19d1b442aa8.svg";
export { ForwardRef as ReactComponent };